import { http } from '../../http';
import { useCustomConfig } from '@/js/composables/useCustomAxiosRequestConfig';
import { __ } from '@/js/stores/expressions';
import {
    AgentAnonymizationAgent,
    RequestApproveAgents,
    ResponseGetAnonymizedAgents,
    ResponseGetApprovedAgents,
    ResponseGetAgentsWaitingForApproval,
} from './types';

export const getAgentsWaitingForApproval = async (
    tenantId: string,
    page: number,
    pageSize: number
): Promise<ResponseGetAgentsWaitingForApproval> => {
    return http
        .backoffice()
        .get<ResponseGetAgentsWaitingForApproval>(
            `/agent-anonymization/${tenantId}/waiting-for-approval`,
            useCustomConfig({
                params: { page, pageSize },
                errorMessage: {
                    500: __('error-load-agent-anonymization-waiting-for-approval'),
                    502: __('error-load-agent-anonymization-waiting-for-approval'),
                },
            })
        )
        .then((response) => response.data);
};

export const getApprovedAgents = async (tenantId: string): Promise<AgentAnonymizationAgent[]> => {
    return http
        .backoffice()
        .get<ResponseGetApprovedAgents>(
            `/agent-anonymization/${tenantId}/approved`,
            useCustomConfig({
                errorMessage: {
                    500: __('error-load-agent-anonymization-approved'),
                    502: __('error-load-agent-anonymization-approved'),
                },
            })
        )
        .then((response) => response.data.agents);
};

export const getAnonymizedAgents = async (
    tenantId: string,
    page: number,
    pageSize: number
): Promise<ResponseGetAnonymizedAgents> => {
    return http
        .backoffice()
        .get<ResponseGetAnonymizedAgents>(
            `/agent-anonymization/${tenantId}/anonymized`,
            useCustomConfig({
                params: { page, pageSize },
                errorMessage: {
                    500: __('error-load-agent-anonymization-anonymized'),
                    502: __('error-load-agent-anonymization-anonymized'),
                },
            })
        )
        .then((response) => response.data);
};

export const approveAgents = async (tenantId: string, agentIds: string[]): Promise<void> => {
    const request: RequestApproveAgents = { agentIds };
    await http.backoffice().post<void>(
        `/agent-anonymization/${tenantId}/approve`,
        request,
        useCustomConfig({
            errorMessage: {
                500: __('error-approve-agent-anonymization'),
                502: __('error-approve-agent-anonymization'),
            },
        })
    );
};

export const revokeApproval = async (tenantId: string, agentId: string): Promise<void> => {
    await http.backoffice().post<void>(
        `/agent-anonymization/${tenantId}/${agentId}/revoke`,
        undefined,
        useCustomConfig({
            errorMessage: {
                500: __('error-revoke-agent-anonymization'),
                502: __('error-revoke-agent-anonymization'),
            },
        })
    );
};
